import type { AppRouter } from '@risksmart-app/trpc/src/routers/router';
import type { GetImpactRatingsWithAppetitesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactRatingsWithAppetitesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { inferRouterOutputs } from '@trpc/server';
import { createQueryHook } from 'src/utils';

type UseGetImpactRatingsWithAppetitesArgs = {
  today: string;
};

type RouterOutputs = inferRouterOutputs<AppRouter>;

type GetImpactRatingsWithAppetitesData =
  RouterOutputs['frontend']['impactRating']['impactRatingsWithAppetites'];

export const useGetImpactRatingsWithAppetites = createQueryHook<
  UseGetImpactRatingsWithAppetitesArgs,
  GetImpactRatingsWithAppetitesData,
  GetImpactRatingsWithAppetitesQuery
>({
  trpcQueryOptions: (trpc, { today }) =>
    trpc.frontend.impactRating.impactRatingsWithAppetites.queryOptions({
      today,
    }),
  mapTrpcDataToGraphQL: (data) => ({ impact_rating: data }),
  graphqlDocument: GetImpactRatingsWithAppetitesDocument,
  graphqlVariables: ({ today }) => ({ today }),
});
